export enum FileTypeEnum {
  PRODUCT_COLA = "PRODUCT_COLA",
  INVOICE_CLIENT = "INVOICE_CLIENT",
  INVOICE_PELICAN = "INVOICE_PELICAN",
  INVOICE_PELICAN_EXCEL = "INVOICE_PELICAN_EXCEL",
  IMPORTER_LICENCE = "IMPORTER_LICENCE",
  IMPORTER_BASIC_PERMIT = "IMPORTER_BASIC_PERMIT",
  IMPORTER_OTHER = "IMPORTER_OTHER",
  EXPEDITION_INVOICE = "EXPEDITION_INVOICE",
  EXPEDITION_QUOTE = "EXPEDITION_QUOTE",
  EXPEDITION_QUOTE_EXCEL = "EXPEDITION_QUOTE_EXCEL",
  EXPEDITION_FORM = "EXPEDITION_FORM",
  EXPEDITION_FORM_EXCEL = "EXPEDITION_FORM_EXCEL",
  EXPEDITION_CUSTOM_INVOICE = "EXPEDITION_CUSTOM_INVOICE",
  EXPEDITION_CUSTOM_INVOICE_EXCEL = "EXPEDITION_CUSTOM_INVOICE_EXCEL",
  EXPEDITION_PRIOR_NOTICE = "EXPEDITION_PRIOR_NOTICE",
  EXPEDITION_DAE = "EXPEDITION_DAE",
  EXPEDITION_SHIPPING_LABEL = "EXPEDITION_SHIPPING_LABEL",
  EXPEDITION_FILES_TO_PRINT = "EXPEDITION_FILES_TO_PRINT",
  EXPEDITION_OTHER = "EXPEDITION_OTHER",
  EXPEDITION_IMPORT_LICENSE = "EXPEDITION_IMPORT_LICENSE",
  EXPEDITION_CERTIFICATE_CHAMPAGNE = "EXPEDITION_CERTIFICATE_CHAMPAGNE",
  EXPEDITION_COMPLEMENTARY_INVOICE = "EXPEDITION_COMPLEMENTARY_INVOICE",
  EXPEDITION_DEPRECATED_FILES = "EXPEDITION_DEPRECATED_FILES",
  OTHER = "OTHER",
}
